import React, { useMemo } from 'react';
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

import RedisAuth from './component/redis/RedisAuth';
import RedisMode from './component/redis/RedisMode';

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';
import { async } from 'regenerator-runtime';

class SettingRedis extends React.Component {

	componentWillMount() {
		this.props.fetchSettingDataInfo(this.props.settingKey.redisAuth.value, this.props.settingKey.redisAuth.keyList, null)
		this.onLoadRedisMode();
	}

	onLoadRedisMode = () => {
		this.props.fetchSettingDataInfo(this.props.settingKey.redisMode.value, this.props.settingKey.redisMode.keyList, null)
	}

	onSaveRedisAuth = (isSingle, value) => {
		this.props.fetchSettingDataUpdate(isSingle, value, 
			{
				type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST,
				key: this.props.settingKey.redisAuth.value,
				keyList: this.props.settingKey.redisAuth.keyList,
				appList: null
			})
	}

	onSaveRedisMode = (isSingle, mode, nodes) => {
		this.props.fetchSettingRedisModeUpdate(isSingle, mode, nodes, 
			{
				type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST,
				key: this.props.settingKey.redisMode.value,
				keyList: this.props.settingKey.redisMode.keyList,
				appList: null
			})
	}

	render() {
		const {t} = this.props;
		return (
			<div>
				{isEmpty(this.props.settingData.redisAuth) ? null : 
					<RedisAuth
						t={this.props.t}
						apps={this.props.apps}
						settingKey={this.props.settingKey.redisAuth}
						settingData={this.props.settingData.redisAuth}
						onSave={this.onSaveRedisAuth}
					/>
				}
				{isEmpty(this.props.settingData.redisMode) ? null : 
					<RedisMode
						t={this.props.t}
						props={this.props}
						optionList={this.props.redisModes}
						settingKey={this.props.settingKey.redisMode}
						settingData={this.props.settingData.redisMode}
						onDataLoad={this.onLoadRedisMode}
						alertMessage={this.props.alertMessage}
						onSave={this.onSaveRedisMode}
					/>
				}
			</div>
		)
	}


}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return {	
		apps: reducers.setting.apps,
		redisModes: reducers.setting.redisModes,
		settingKey: reducers.setting.settingKey,
		settingData: reducers.setting.settingData,
		apiCalling: reducers.apiCalling.apiCalling
	}
}

// 컴포넌트의 함수형 props를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return {
		fetchSettingDataInfo: async (key, keyList, appList) => {dispatch({type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST, key: key, keyList: keyList, appList: appList})},
		fetchSettingDataUpdate: (isSingle, value, reloadAction) => {dispatch({type: types.FETCH_SET_SETTING_DATA_UPDATE_REQUEST, isSingle: isSingle, value: value, reload: reloadAction})},	
		fetchSettingRedisModeUpdate: (isSingle, mode, nodes, reloadAction) => {dispatch({type: types.FETCH_SET_SETTING_REDIS_MODE_UPDATE_REQUEST, isSingle: isSingle, mode: mode, nodes: nodes, reload: reloadAction})},	
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SettingRedis))